import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import auth from './stores/auth.js'
import user from './stores/user.js'


Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  modules: {
      auth,
      user
  },
  state: {
      token: localStorage.getItem('token'),
      errors: [],
      sidebarShow: 'responsive',
      sidebarMinimize: false
  },
  getters: {
      isAuth: state => {
          return state.token != "null" && state.token != null
      }
  },
  mutations: {
      SET_TOKEN(state, payload) {
          state.token = payload
      },
      SET_ERRORS(state, payload) {
          state.errors = payload
      },
      CLEAR_ERRORS(state) {
          state.errors = []
      },
      toggleSidebarDesktop (state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarOpened ? false : 'responsive'
      },
      toggleSidebarMobile (state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarClosed ? true : 'responsive'
      },
      set (state, [variable, value]) {
        state[variable] = value
      },
  }
})